import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getContrastTextColorValue } from '../../utils/common';
import ConditionalWrapperDivs from '../HelperComponents/ConditionalWrapperDivs';

const ResidenceFilterOptionTags = ( {
  activeFilterSelections,
  setActiveFilterSelections,
  categoryId,
} ) => {
  // Generate 'tags' on the Category panel with the user's active selections.
  const activeCategoryFilterSelections = activeFilterSelections[categoryId];
  const selectionCount = Object.keys( activeCategoryFilterSelections ).length;
  const firstSelection = Object.values( activeCategoryFilterSelections )[0];

  const tagStyle = ( value ) => {
    let style = null;
    if ( value?.color ) {
      style = {
        backgroundColor: value?.color,
        borderColor: value?.color,
        color: getContrastTextColorValue( value?.color ),
      };
    }
    return style;
  };

  const classColor = ( value ) => {
    if ( value?.color ) {
      return getContrastTextColorValue( value?.color );
    }
  };

  const onTagRemoveClick = ( uuid, event ) => {
    // Stop the click from propagating to parent elements
    event.stopPropagation();

    // Making a deep copy of the filter selection
    const activeFilterSelectionsCopy = { ...activeFilterSelections };

    if ( activeFilterSelectionsCopy[categoryId][uuid] ) {
      delete activeFilterSelectionsCopy[categoryId][uuid];
    }

    // If category is now empty, remove it
    if ( Object.keys( activeFilterSelectionsCopy[categoryId] ).length === 0 ) {
      delete activeFilterSelectionsCopy[categoryId];
    }

    setActiveFilterSelections( activeFilterSelectionsCopy );
  };

  return (
    <ConditionalWrapperDivs
      condition={selectionCount > 0}
      classNamesArray={[ 'onImageDropdown__optionTags' ]}
    >
      { selectionCount > 4 ? (
        <span key="summary" className="onImageDropdown__optionTag">
          <ConditionallyShortenedSelectionLabel selection={firstSelection} />
          {' '}
          +
          { selectionCount - 1 }
          {' '}
          more
        </span>
      ) : Object.entries( activeCategoryFilterSelections ).map( ( [ uuid, value ] ) => (
        <span
          key={uuid}
          className={classNames( 'onImageDropdown__optionTag', {
            [`onImageDropdown__optionTag--${classColor( value )}`]: value,
          } )}
          style={tagStyle( value )}
          onClick={( e ) => {
            onTagRemoveClick( uuid, e );
          }}
          role="button"
          tabIndex={0}
          onKeyPress={( e ) => {
            if ( e.key === 'Enter' || e.key === ' ' ) {
              onTagRemoveClick( uuid, e );
            }
          }}
        >
          <ConditionallyShortenedSelectionLabel selection={value} />
          <span className="onImageDropdown__optionTagRemove" aria-hidden="true" aria-label="Remove filter" />
        </span>
      ) )}

    </ConditionalWrapperDivs>
  );
};

// Shorten the label if it is too long.
const ConditionallyShortenedSelectionLabel = ( { selection } ) => {
  let shortenedLabel = selection?.label || selection;
  shortenedLabel = shortenedLabel.length > 22 ? `${shortenedLabel.substring( 0, 22 )}...` : shortenedLabel;
  return shortenedLabel;
};

ResidenceFilterOptionTags.propTypes = {
  activeFilterSelections: PropTypes.objectOf( PropTypes.object ).isRequired,
  setActiveFilterSelections: PropTypes.func.isRequired,
  categoryId: PropTypes.string.isRequired,
};

ConditionallyShortenedSelectionLabel.propTypes = {
  selection: PropTypes.oneOfType( [ PropTypes.string,
    PropTypes.shape( {
      label: PropTypes.string,
    } ) ] ).isRequired,
};

export default ResidenceFilterOptionTags;
